/* HoneMD carousel - one tiny controller for every scroll-snap track
   (offers, treatments, testimonials, locations, instagram).
   Markup contract:
     [data-hm-carousel]
       .hm-track            (the scrolling container)
       [data-hm-prev] / [data-hm-next]   (optional arrow buttons)
       [data-hm-progress-bar]            (optional accent progress fill) */
(function () {
  function setup(root) {
    var track = root.querySelector('.hm-track');
    if (!track) return;
    var prev = root.querySelector('[data-hm-prev]');
    var next = root.querySelector('[data-hm-next]');
    var bar = root.querySelector('[data-hm-progress-bar]');

    function step() {
      var item = track.children[0];
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      root.classList.toggle('hm-static', max <= 1);
      if (bar) {
        var visible = Math.min(1, track.clientWidth / track.scrollWidth);
        var pos = max > 0 ? x / max : 0;
        bar.style.width = (visible * 100) + '%';
        bar.style.left = (pos * (100 - visible * 100)) + '%';
      }
      if (prev) prev.toggleAttribute('disabled', x <= 1);
      if (next) next.toggleAttribute('disabled', x >= max - 1);
    }

    function behavior() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      return reduce ? 'auto' : 'smooth';
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior() }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hm-carousel]').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-init sections added/edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
